<script setup lang="ts">
import { IMeditationRoom } from '@/types/meditation';

interface Props {
  value: number;
  name: string;
  modelValue: number;
  label: string;
  type: 'user' | 'admin';
  selectedRoomItem: IMeditationRoom;
  onConfirm: (mode: 'edit' | 'create', selectedRoomItem: IMeditationRoom) => void;
  deleteOnConfirm: (id: number) => void;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  'update:modelValue': [value: number];
  'open-nested-modal': [
    modalType: string,
    modalProps: {
      mode: string;
      selectedRoomItem?: IMeditationRoom;
      onConfirm: (mode: 'edit' | 'create', selectedRoomItem: IMeditationRoom) => void;
    },
  ];
}>();

const handleEditClick = () => {
  emit('open-nested-modal', 'nested-mindshare-edit', {
    mode: 'edit',
    selectedRoomItem: props.selectedRoomItem,
    onConfirm: props.onConfirm,
  });
};

/* TODO: 삭제 기능 추가 */
const handleDeleteClick = () => {
  props.deleteOnConfirm(props.selectedRoomItem.id);
};
</script>

<template>
  <label
    class="flex flex-row h-[48px] justify-between items-center gap-2 py-2 px-0 border-b border-gray-200 cursor-pointer font-bold"
  >
    <span class="text-[16px]" :class="{ 'text-[#519ea6]': modelValue === value }">{{ label }}</span>
    <div v-if="type === 'admin'" class="flex flex-row gap-2">
      <img @click="handleEditClick" class="w-[28px] h-[28px]" src="/images/icons/pen-edit.png" alt="edit" />
      <img @click="handleDeleteClick" class="w-[28px] h-[28px]" src="/images/icons/trash-delete.png" alt="delete" />
    </div>
    <input
      v-else
      :value="value"
      :checked="modelValue === value"
      type="radio"
      :name="name"
      class="w-4 h-4 text-[#519ea6] !border-[#519ea6] focus:ring-[#519ea6] accent-[#519ea6]"
      @change="$emit('update:modelValue', value)"
    />
  </label>
</template>
